import useTranslation from "../../../helpers/translationTexts/useTranslation";
import Image from "next/image";
import { Text, Wrapper } from "./CupSection.components";
import tropfyImg from "/public/images/calendar/trophy.png";

const CupSection: React.FC = () => {
  const dailyChallengeText = useTranslation("dailyChallenge");

  return (
    <Wrapper>
      <Image alt="cup image" priority src={tropfyImg} sizes="100vw" />
      <Text>{dailyChallengeText}</Text>
    </Wrapper>
  );
};

export default CupSection;
